export function noBusinessesMessage(industry, location) {
  return `Google returned no businesses for "${industry} in ${location}". Try a more specific location, for example "Gulfport, Florida", and check the Google Domain matches the country.`;
}
